<div class="card mb-3">
    <div class="card-content">
        <div class="title font-20 fontMedium">{{'restaurant.Publish Restaurant' | translate }}</div>
        <div class="row no-gutters mt-4">
            <div class="col-lg-12 col-md-12 d-flex align-items-center">
                    <ng-container *ngIf="!restaurantProfile.canPublish">
                        <mat-icon class="card-warning">warning</mat-icon>
                        <div class="card-head-content mr-5 warning-text">
                            <p class="mb-1 font-16 fontRegular">{{"restaurant.Awaiting to complete the restaurants primary data in order to publish the restaurant" | translate}}</p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="restaurantProfile.canPublish">
                        <mat-icon class="card-success">check</mat-icon>
                        <div class="card-head-content mr-5">
                            <p class="mb-1 font-16 fontRegular">{{"restaurant.Well done! you have completed the main data" | translate}}</p>
                            <p class="m-0 font-12 fontMedium grey-color">{{"restaurant.Now after pressing the button below, BonTech will review your request then publish your restaurant" | translate}}</p>
                        </div>
                    </ng-container>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-lg-12">
                <p class="font-12 fontMedium grey-color">{{ 'restaurant.Its recommended to complete the restaurant data in the following sequence' | translate }}</p>
            </div>
        </div>
        <div class="row">
            <div class="checklists d-flex justify-content-start">
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.floor">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.floor"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/floorskitchens/floorPlan"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.floor || !restaurantProfile.canLenkpublishStatus?.floor}">
                        {{"publish.Create Floor" | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{"publish.At least: one floor with one table" | translate }}</p>
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.kitchen">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.kitchen"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/floorskitchens/kitchens"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.kitchen || !restaurantProfile.canLenkpublishStatus?.kitchen}">
                        {{'publish.Add Kitchen(s)' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{"publish.At least: one" | translate }}</p>
                    </div>
                </div>
                <!-- Host -->
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.host">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.host"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/staff"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.host || !restaurantProfile.canLenkpublishStatus?.host}">
                        {{'publish.Add Host' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{'publish.At least: one' | translate }}</p>
                    </div>
                </div>
                <!-- Chef -->
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.chef">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.chef"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/staff"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.chef || !restaurantProfile.canLenkpublishStatus?.chef}">
                        {{'publish.Add Chef' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{'publish.At least: one' | translate }}</p>
                    </div>
                </div>
                <!-- Res Chef -->
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.respChef">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.respChef"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/staff"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.respChef || !restaurantProfile.canLenkpublishStatus?.respChef}">
                        {{'publish.Add respChef' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{'publish.At least: one' | translate }}</p>
                    </div>
                </div>
                <!-- Waiter -->
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.waiter">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.waiter"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/staff"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.waiter || !restaurantProfile.canLenkpublishStatus?.waiter}">
                        {{'publish.Add Waiter' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{'publish.At least: one' | translate }}</p>
                    </div>
                </div>
                <!-- Cashier -->
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.cashier">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.cashier"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/staff"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.cashier || !restaurantProfile.canLenkpublishStatus?.cashier}">
                        {{'publish.Add Cashier' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{'publish.At least: one' | translate }}</p>
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.ingredientsunits">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.ingredientsunits"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/stockConfig/Ingredients"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.ingredientsunits || !restaurantProfile.canLenkpublishStatus?.ingredientsunits}">
                        {{'publish.Add Ingredients Units Configuration' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{"publish.At least: one" | translate }}</p>
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.supplier">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.supplier"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/stockConfig/suppliers"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.supplier || !restaurantProfile.canLenkpublishStatus?.supplier}">
                        {{'publish.Suppliers' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{"publish.At least: one" | translate }}</p>
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.transaction">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.transaction"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/stockConfig/stockTransaction"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.transaction || !restaurantProfile.canLenkpublishStatus?.transaction}">
                        {{'publish.Add Stock Transaction(s)' | translate }}
                        </a>
                        <!-- <p class="font-10 fontRegular grey-color">At least: one floor with one table</p> -->
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.menuitemcategory">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.menuitemcategory"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/menu-management/menu-categories"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.menuitemcategory || !restaurantProfile.canLenkpublishStatus?.menuitemcategory}">
                        {{"publish.Add Menu Items Categories" | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{"publish.At least: one" | translate }}</p>
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.menuitem">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.menuitem"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        [routerLink]="['/admin/menu-management/menu-items']" (click)="navigateToSideBar(restaurantId)"  [ngClass]="{'disable-link': restaurantProfile.publishStatus?.menuitem}">
                        {{'publish.Add Menu Items' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{"publish.At least: one" | translate }}</p>
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.menu">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.menu"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/menu-management/menus"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.menu || !restaurantProfile.canLenkpublishStatus?.menu}">
                        {{'publish.Add Menu' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{"publish.At least: one" | translate }}</p>
                    </div>
                </div>
                <div class="checklist-item d-flex">
                    <mat-icon class="check-icon" *ngIf="restaurantProfile.publishStatus?.dayavailable">check</mat-icon>
                    <div class="uncheck-icon" *ngIf="!restaurantProfile.publishStatus?.dayavailable"></div>
                    <div class="checklist-content">
                        <a class="font-12 fontRegular text-color"
                        routerLink="/admin/availability/hoursConfig"
                        [ngClass]="{'disable-link': restaurantProfile.publishStatus?.dayavailable || !restaurantProfile.canLenkpublishStatus?.dayavailable}">
                        {{'publish.Availability' | translate }}
                        </a>
                        <p class="font-10 fontRegular grey-color">{{'publish.At least: one day' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <a class="btn-orange mt-1 ml-3 uppercase" mat-stroked-button
                *ngIf="restaurantProfile.showPublishButton"
                [disabled]="!restaurantProfile.canPublish"
                (click)="publish()">{{'restaurant.Ready to be published' | translate}}</a>
        </div>
    </div>
</div>
